import React, { useMemo } from 'react';

import { isGoGameEnv } from 'App/constants';

import { Actions, Action, FileDownloadIcon } from '@gogame/components';
import { ViewSettingsAction } from './ViewSettingsAction';
import { BreakdownModeAction } from './BreakdownModeAction';
import { AddChartAction } from './AddChartAction';
import { RemoveChartAction } from './RemoveChartAction';
import { ChartSettingsAction } from './ChartSettingsAction';
import { AnnotationsAction } from './AnnotationsAction';

import { useChartState, useColorGetter } from '../hooks';

export const ChartActions = ({
  annotationUniqueId,
  metrics,
  chartSeries,
  onChangeViewSettings,
  disabledSettings,
  disabledBreakdown,
  onExport,
  onExportGoogleDrive,
  onExportWhenReady,
  onOpenSubscriptionsForm,
}) => {
  const mixedTypesColorGetter = useColorGetter(chartSeries);

  const withPie = useMemo(
    () =>
      !!chartSeries?.find(
        (el) =>
          !el.metrics.find(
            ({ metricId }) => metricId === 'RoasD7MmmBudgetInsight'
          )
      ),
    [chartSeries]
  );

  const chartState = useChartState();

  return (
    <Actions limit={10}>
      <Action component={() => <AnnotationsAction id={annotationUniqueId} />} />
      <Action
        component={() => <BreakdownModeAction disabled={disabledBreakdown} />}
      />
      <Action
        component={() => (
          <ViewSettingsAction
            metrics={metrics}
            colorGetter={mixedTypesColorGetter}
            onChange={onChangeViewSettings}
            withPie={withPie}
          />
        )}
      />
      <Action
        component={() => <ChartSettingsAction disabled={disabledSettings} />}
      />
      <Action
        icon={<FileDownloadIcon />}
        disabled={!chartState.metrics?.length}
      >
        <Action
          label={'Export'}
          onClick={onExport}
          disabled={chartState.chartViewSettings.type === 'pie'}
        />
        {isGoGameEnv && (
          <Action
            label={'Export to Google Sheets'}
            onClick={onExportGoogleDrive}
          />
        )}
        {isGoGameEnv && (
          <Action label={'Send to email'} onClick={onExportWhenReady} />
        )}
        {isGoGameEnv && (
          <Action label={'Subscribe'} onClick={onOpenSubscriptionsForm} />
        )}
      </Action>
      <Action component={() => <AddChartAction />} />
      <Action component={() => <RemoveChartAction />} />
    </Actions>
  );
};
